import styled from 'styled-components';

const Container = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
  justify-content: space-between;
`;

const ScrollableContainer = styled(Container)`
  overflow-y: scroll;
  position: relative;
`;

const ValuationDetailsContainer = styled.div`
  /**
   * This ensures that the parent container does not cover the borders of child elements
   */
  border: 4px solid transparent;
`;

const ActionsContainer = styled.div`
  display: flex;
  gap: ${({ theme }) => theme.spacing.S8};
  /** 
   * The width associated with the button border adds extra height to the Container component, beyond the height value.
   * 
   * Adding padding to this element increases the size of the content of that component to match that extra height, 
   * ensuring that there is no jump on scroll to the bottom of the container.
   */
  padding: ${({ theme }) => theme.spacing.S2};
  /**
   * Hides content that may otherwise appear in the space around the buttons.
   */
  background-color: ${({ theme }) => theme.colors.WHITE};
`;

export {
  Container,
  ScrollableContainer,
  ValuationDetailsContainer,
  ActionsContainer,
};
